import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=d0d46a60"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0d46a60')) {
      api.createRecord('d0d46a60', component.options)
    } else {
      api.reload('d0d46a60', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=d0d46a60", function () {
      api.rerender('d0d46a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Groups.vue"
export default component.exports